import { useMemo, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";

// Seleção múltipla de bairros com busca (Iter 98). `conflicts[bairro_id]` lista nomes de
// OUTRAS rotas que já contêm o bairro — avisa o admin que a entrega exigirá escolha manual.
export function BairrosPicker({ bairros, value, onChange, conflicts = {} }) {
  const [q, setQ] = useState("");
  const sel = useMemo(() => new Set(value || []), [value]);
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    return s ? bairros.filter((b) => (b.nome || "").toLowerCase().includes(s)) : bairros;
  }, [bairros, q]);
  const toggle = (id) => { const n = new Set(sel); if (n.has(id)) n.delete(id); else n.add(id); onChange([...n]); };
  const allVisible = list.length > 0 && list.every((b) => sel.has(b.id));
  const toggleVisible = () => { const n = new Set(sel); list.forEach((b) => (allVisible ? n.delete(b.id) : n.add(b.id))); onChange([...n]); };

  return (
    <div className="space-y-2" data-testid="rota-bairros-picker">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <Label>Bairros da rota <span className="text-xs font-normal text-muted-foreground" data-testid="rota-bairros-count">({sel.size} selecionado{sel.size === 1 ? "" : "s"})</span></Label>
        <div className="flex gap-1">
          <Button type="button" size="sm" variant="ghost" className="h-7 text-xs" onClick={toggleVisible} disabled={list.length === 0} data-testid="rota-bairros-toggle-visible">
            {allVisible ? "Desmarcar visíveis" : "Marcar visíveis"}
          </Button>
          <Button type="button" size="sm" variant="ghost" className="h-7 text-xs" onClick={() => onChange([])} disabled={sel.size === 0} data-testid="rota-bairros-clear">Limpar</Button>
        </div>
      </div>
      <div className="relative">
        <Search className="w-4 h-4 absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar bairro..." className="pl-8 h-9" data-testid="rota-bairros-search" />
      </div>
      <div className="max-h-56 overflow-y-auto rounded-md border divide-y" data-testid="rota-bairros-list">
        {list.map((b) => {
          const others = conflicts[b.id] || [];
          return (
            <label key={b.id} className={`flex items-center gap-2 px-3 py-1.5 text-sm cursor-pointer hover:bg-orange-50/60 ${sel.has(b.id) ? "bg-orange-50/40" : ""}`}>
              <input type="checkbox" checked={sel.has(b.id)} onChange={() => toggle(b.id)} className="accent-orange-600 w-4 h-4" data-testid={`rota-bairro-chk-${b.id}`} />
              <span className="flex-1 truncate">{b.nome}</span>
              {others.length > 0 && (
                <span className="text-[10px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-1.5 whitespace-nowrap" title={`Também em: ${others.join(", ")}`}>
                  +{others.length} rota{others.length === 1 ? "" : "s"}
                </span>
              )}
            </label>
          );
        })}
        {list.length === 0 && (
          <div className="text-center text-xs text-muted-foreground py-6">
            {bairros.length === 0 ? "Nenhum bairro cadastrado — cadastre em Bairros primeiro" : "Nenhum bairro encontrado"}
          </div>
        )}
      </div>
    </div>
  );
}
